'use client';

import LinkedButton from 'components/buttons/LinkedButton';
import VideoPlayer from 'components/media/VideoPlayer';
import { ComponentFields } from 'types/content';
import { selectVideoSource } from 'utils/mediaUtils';

const ContentComponent = ({ data, onContinue }: ComponentFields) => {
  // Get component data
  const buttonlink = data.elements.buttonlink?.value;
  const buttontext = data.elements.buttontext?.value;
  const subtitle = data.elements.subtitle?.value;
  const title = data.elements.title?.value;
  const video = data.elements.video?.value;

  return (
    <section className="container-xl main-wrapper">
      {title && (
        <h1 className="append-dot" data-testid="content-title">
          {title}
        </h1>
      )}
      {subtitle && (
        <h2 className="append-dot" data-testid="content-subtitle">
          {subtitle}
        </h2>
      )}
      {video && (
        <div className="mx-auto">
          <VideoPlayer
            dynamicText={video.dynamicText?.url}
            source={selectVideoSource(video)}
            stillImage={video.videoStillImage?.url}
            track={video.closedCaption?.url}
            transcript={video.videoTranscript}
            onContinue={onContinue}
          />
        </div>
      )}
      {buttontext && buttonlink && (
        <LinkedButton
          href={`/${buttonlink}`}
          size="quarter-width"
          title={buttontext}
          variant="filled"
        />
      )}
      {buttontext && !buttonlink && (
        <button
          className="button primary quarter-width"
          onClick={onContinue}
          data-testid="content-continue-button"
        >
          {buttontext}
        </button>
      )}
    </section>
  );
};

export default ContentComponent;
